import { useCallback, useState, type ReactNode } from 'react';

/**
 * Sheet 内嵌 Modal / Select 等浮层时，默认 portal 到 document.body 会被外层 Sheet
 * 的 focus scope 标记为 inert，导致无法点击。将浮层 portal 到 Sheet 内此容器即可。
 */
export function SheetOverlayPortalHost({
  children,
  onHostChange,
}: {
  children: ReactNode;
  onHostChange: (host: HTMLElement | null) => void;
}) {
  const handleRef = useCallback(
    (node: HTMLDivElement | null) => {
      onHostChange(node);
    },
    [onHostChange]
  );

  return (
    <>
      {children}
      <div
        ref={handleRef}
        className="pointer-events-none fixed inset-0 z-[100] [&>*]:pointer-events-auto"
        data-sheet-overlay-portal
      />
    </>
  );
}
